// React for Website

import React from "react";
//outsource
import { Input } from "antd";

//components

const { Search } = Input;

const BranchStaffSearch = ({ handleChange }) => {
  // -------------------------- VAR --------------------------
  // -------------------------- STATE --------------------------

  // -------------------------- REDUX --------------------------
  // -------------------------- FUNCTION --------------------------

  // -------------------------- EFFECT --------------------------

  // -------------------------- RENDER --------------------------

  // -------------------------- MAIN --------------------------
  return (
    <Search
      placeholder="Search by staff full name/ preferred name"
      onChange={handleChange}
      allowClear={true}
    />
  );
};

export default BranchStaffSearch;
